import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlowTypes } from '@interfaces/models/flow-types';
import {
  DocumentScanResponse,
  ViadocExpectableLabel,
  ViadocUploadStep,
} from '@interfaces/models/viadoc-types';
import { Observable } from 'rxjs';

export interface ViadocScanParams {
  expectedTypes: ViadocExpectableLabel[];
  uploadStep: ViadocUploadStep;
  flowType: FlowTypes | null;
}

@Injectable({ providedIn: 'root' })
export class ViadocService {
  constructor(private http: HttpClient) {}

  scanDocument(file: Blob, params: ViadocScanParams): Observable<DocumentScanResponse> {
    const formData = new FormData();

    formData.append('file', file, 'document-scan.pdf');

    const queryParams: Record<string, string> = {
      expectedTypes: params.expectedTypes.join(','),
      uploadStep: params.uploadStep,
    };

    if (params.flowType) {
      queryParams['flowType'] = params.flowType;
    }

    return this.http.post<DocumentScanResponse>('secure/document-scan', formData, {
      params: queryParams,
    });
  }
}
